import { input, type SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { Component, output } from '@angular/core';

import { AnySymbol, SymbolComponent } from '@core/symbol-legacy';
import {
  BadgeComponent,
  CheckboxComponent,
  DividerComponent,
  HeadingComponent,
  IconComponent,
} from '@core/user-interface-legacy';

@Component({
  selector: 'rt-table-list-group-heading',
  templateUrl: './table-list-group-heading.html',
  styleUrls: ['./table-list-group-heading.less'],
  host: {
    '[style.cursor]': '"pointer"',
    '[style.userSelect]': '"none"',
  },
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CheckboxComponent,
    HeadingComponent,
    IconComponent,
    DividerComponent,
    BadgeComponent,
    SymbolComponent,
  ],
})
export class TableListGroupHeadingComponent {
  public readonly state = input<'normal' | 'collapsed'>(undefined!);
  public readonly name = input<string>(undefined!);
  public readonly counter = input<number>(undefined!);
  public readonly selectable = input<boolean>(undefined!);
  public readonly selectedCount = input<number>(undefined!);
  public withDivider = input<boolean>(true);
  public symbol = input<AnySymbol | null>(null);

  public selectedChange = output<boolean>();

  public allSelected: boolean;
  public partiallySelected: boolean;

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedCount || changes.counter) {
      this.allSelected = this.selectedCount() === this.counter();
      const selectedCount = this.selectedCount();
      this.partiallySelected = !!selectedCount && selectedCount < this.counter();
    }
  }
}
